import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./fonts.css";
import "./tokens.css";
import "./styles.css";
import "./portal.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root element #root is missing from index.html");

// In a browser the address bar follows the screen, so Back leaves a table for
// the portal and a link can open one directly.
createRoot(container).render(
  <StrictMode>
    <App routing />
  </StrictMode>,
);
